var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophySolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_11507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 0.5H18.3333C15.5729 0.5 13.3229 2.75664 13.4271 5.48945C13.4479 6.03809 13.4688 6.58672 13.5 7.125H2.5C1.11458 7.125 0 8.23262 0 9.60938C0 19.1949 3.48958 25.8613 8.17708 30.385C12.7917 34.8465 18.4167 37.0928 22.5625 38.2314C25 38.9043 26.6667 40.9229 26.6667 42.9518C26.6667 45.1152 24.8958 46.875 22.7188 46.875H20C18.1562 46.875 16.6667 48.3553 16.6667 50.1875C16.6667 52.0197 18.1562 53.5 20 53.5H40C41.8438 53.5 43.3333 52.0197 43.3333 50.1875C43.3333 48.3553 41.8438 46.875 40 46.875H37.2812C35.1042 46.875 33.3333 45.1152 33.3333 42.9518C33.3333 40.9229 34.9896 38.8939 37.4375 38.2314C41.5938 37.0928 47.2188 34.8465 51.8333 30.385C56.5104 25.8613 60 19.1949 60 9.60938C60 8.23262 58.8854 7.125 57.5 7.125H46.5C46.5312 6.58672 46.5521 6.04844 46.5729 5.48945C46.6771 2.75664 44.4271 0.5 41.6667 0.5ZM5.09375 12.0938H13.8854C14.8333 21.4205 16.9271 27.6521 19.2917 31.8238C16.6979 30.6852 14 29.0807 11.6667 26.824C8.33333 23.6047 5.625 18.9568 5.10417 12.0938H5.09375ZM48.3438 26.824C46.0104 29.0807 43.3125 30.6852 40.7188 31.8238C43.0833 27.6521 45.1771 21.4205 46.125 12.0938H54.9167C54.3854 18.9568 51.6771 23.6047 48.3542 26.824H48.3438Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_11507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophySolid1);
export default __webpack_public_path__ + "static/media/trophy-solid 1.d2ce5e314bb1986bbecd2f857c152b15.svg";
export { ForwardRef as ReactComponent };